<script>
import AttachmentConstants from "@common/constants/AttachmentConstants";

const IconMixin = {
  methods: {
    setIcon(file) {
      let fileExt = this.findFileExt(file);
      if (AttachmentConstants.images.includes(fileExt)) {
        let IMAGE = file.url;
        return 'icon-png';
      } else if (AttachmentConstants.pdf.includes(fileExt)) {
        return 'icon-pdf';
      } else if (AttachmentConstants.zpl.includes(fileExt)) {
        return 'icon-zpl';
      }
    },
    findFileExt(fileName) {
      if(fileName) {
        const index1 = ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
        let index2 = fileName.indexOf("?");
        index2 = index2 === -1 ? fileName.length : index2;
        return fileName.slice(index1, index2).toLowerCase();
      }
    },
  }
};
export default IconMixin;
</script>
